import React from 'react';
import { Space, Tag, Tooltip } from 'antd';
import { getExecutionDisplayInfo } from '@/utils/getExecutionDisplayInfo';

export type WorkOrderExecutionBadgeProps = {
  executionScope?: string | null;
  size?: 'default' | 'compact';
};

export const WorkOrderExecutionBadge: React.FC<WorkOrderExecutionBadgeProps> = ({
  executionScope,
  size = 'default',
}) => {
  const info = getExecutionDisplayInfo(executionScope);
  const tagSize = size === 'compact' ? 'small' : undefined;
  const isFab = info.badgeColor === 'fabrication';

  const scopeTag = (
    <Tag color={isFab ? 'blue' : 'default'} style={size === 'compact' ? { margin: 0 } : undefined}>
      {info.scopeLabel}
    </Tag>
  );

  const modeTag = (
    <Tag color={isFab ? 'processing' : 'default'} style={size === 'compact' ? { margin: 0 } : undefined}>
      {isFab ? 'Unit-wise' : 'BOQ-Line'}
    </Tag>
  );

  const deliveryTag = (
    <Tag color={isFab ? 'blue' : 'default'} style={size === 'compact' ? { margin: 0 } : undefined}>
      {info.partialDeliveryAllowed ? 'Partial Delivery ✓' : 'Partial Delivery ✗'}
    </Tag>
  );

  const tooltipTitle = info.procurementTooltip ? (
    <span>
      {info.tooltip}
      <br />
      <br />
      {info.procurementTooltip}
    </span>
  ) : (
    info.tooltip
  );

  return (
    <Tooltip title={tooltipTitle}>
      <Space size={size === 'compact' ? 4 : 8} wrap style={{ maxWidth: '100%' }}>
        {scopeTag}
        {modeTag}
        {deliveryTag}
      </Space>
    </Tooltip>
  );
};

export default WorkOrderExecutionBadge;
